import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const AwaReportsLayout = lazy(() => import('@/pages/awaReports/layout'));
const AwaReportsListPage = lazy(() => import('@/pages/awaReports'));
const AwaLayout = lazy(() => import('@/pages/awa/layout'));
const AwaCreatePage = lazy(() => import('@/pages/awa/create'));
const AwaViewPage = lazy(() => import('@/pages/awa/view'));

/**
 * UG-4505 — AWA response routes, mirroring the legacy split exactly:
 * `/awa-reports` is the "Reported AWA" grid (legacy `awa-reports/page.tsx` —
 * there was never an `/awa` index page), while `/awa/*` holds the standalone
 * flows: `create` (technician submission) and `:id/view` (read view the grid
 * links into). The job-scoped `/jobs/:jobId/awa` page lives in the jobs group
 * (job detail shell); the per-market template editor in the markets group.
 * Permissions: `@/config/auth/routeAccess` (`awaResponse.view` subtree for
 * the reads, `awaResponse.create` for `/awa/create` — ported 1:1).
 */
export const awaRoutes: RouteConfig[] = [
  {
    path: '/awa-reports',
    layout: DashboardLayout,
    children: [
      {
        path: '',
        layout: AwaReportsLayout,
        children: [{ path: '', element: AwaReportsListPage }],
      },
    ],
  },
  {
    path: '/awa',
    layout: DashboardLayout,
    children: [
      {
        path: '',
        layout: AwaLayout,
        children: [
          { path: '/create', element: AwaCreatePage },
          { path: '/:id/view', element: AwaViewPage },
        ],
      },
    ],
  },
];
